import { render, staticRenderFns } from "./study-center.vue?vue&type=template&id=fcfc383a&scoped=true&"
import script from "./study-center.vue?vue&type=script&lang=js&"
export * from "./study-center.vue?vue&type=script&lang=js&"
import style0 from "./study-center.vue?vue&type=style&index=0&id=fcfc383a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfc383a",
  null
  
)

export default component.exports